import React, { Component } from 'react';
import {Button} from 'rmwc/Button';

import * as api from '../api/api';
import StatusMessage from '../util/StatusMessage'

class CertificationDetail extends Component{

  constructor(props) {
    super(props)
     this.state = {
      errorMsg: '',
    }

    this.fetchReport = this.fetchReport.bind(this)
  }

  fetchReport(e, rollNumber, year) {
    this.props.onLoadingState(true)
    let year_num
    year_num = parseInt(year, 10)
    if (year_num < 2018) {
      api.getTPOReport(this.props.accessToken,rollNumber, year)
      .then((result) => {
         if (result instanceof Blob){
          this.setState({ errorMsg: '' })
          this.props.onLoadingState(false, '')
          const url = window.URL.createObjectURL(result);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'file.pdf');
          document.body.appendChild(link);
          link.click();
        }
        else{
          this.setState({ errorMsg: 'Unable to download reports. Please contact Administrator' })
          this.props.onLoadingState(false, 'Unable to download reports. Please contact Administrator')
        }      
      })
    }
    else{
      api.downloadTPOReport(this.props.accessToken, year, rollNumber)
      .then((result) => {
         if (result instanceof Blob){
          this.setState({ errorMsg: '' })
          this.props.onLoadingState(false, '')
          const url = window.URL.createObjectURL(result);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'tporeport.pdf');
          document.body.appendChild(link);
          link.click();
        }
        else{
          this.setState({ errorMsg: 'Unable to download reports. Please contact Administrator' })
          this.props.onLoadingState(false, 'Unable to download reports. Please contact Administrator')
        }      
      }).catch((err) => {
          this.setState({ errorMsg: 'Unable to downlod reports. Plaase contact Admin' })
          this.props.onLoadingState(false, 'Unable to download reports. Please contact Admin')
      })
    }

    
  }

  render(){

    let fetchReportFn = this.fetchReport
    let year = this.props.tpoAchievement.cycle_name
    let tableBody = <tbody>
        {this.props.tpoAchievement.tpo_certification_detail.map(function(detail) {
            return (
              <tr>
                <td>{detail.roll_number}</td>
                <td><Button outlined className="button-link" onClick={((e) => fetchReportFn(e, detail.roll_number, year))}>Download</Button></td>
                <td>{detail.tpo_test_track}</td>
                <td>{detail.national_rank}</td>
                <td>{detail.regional_rank}</td>
                <td>{detail.subject_rank}</td>
                <td>{detail.city_rank}</td>
              </tr>
            )
        })}
      </tbody>

    return (
      <div>

        <h4> TPO {this.props.tpoAchievement.cycle_name} </h4>
        <div>
          <table>
            <thead>
              <tr>
                <th rowspan="2">Roll No</th>
                <th rowspan="2">Performance Report</th>
                <th rowspan="2">Test Track</th>
                <th colspan="4">Ranks</th>
              </tr>
              <tr>
                <th>National</th>
                <th>Regional</th>
                <th>Subject</th>
                <th>City</th>
              </tr>
            </thead>
            {tableBody}
          </table>
          <StatusMessage error_msg = {this.state.errorMsg}/>
        </div>
      </div>
    )
  }
}

export default CertificationDetail;



// WEBPACK FOOTER //
// ./src/views/CertificationDetail.jsx